import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import {injectIntl} from "react-intl";

import SimpleDropDownTemplate from '../../../../templates/PageLayout/DropDowns/SimpleDropDown/SimpleDropDown.rt';

class SimpleDropDown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: props.isOpened || false,
      activeValue: props.activeValue,
      values: props.values,
      disabled: props.disabled || false,
      underlineText: props.underlineText || ''
    }
  }

  componentDidMount() {
    $(document).on('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    $(document).off('click', this.handleDocumentClick);
  }

  setRootRef = element => {
    this.root = element;
  }

  handleDocumentClick = (e) => {
    let el = $(e.target);
    if(el.hasClass('dropdown-container') || $(this.root).find(el).length > 0) {
      return;
    }
    this.setState({isOpened: false});
  }

  handleChange = (value) => {
    this.setState({isOpened: !this.state.isOpened});

    if (value) {
      this.props.onChange(value);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      activeValue: nextProps.activeValue,
      values: nextProps.values,
      disabled: nextProps.disabled,
      underlineText: nextProps.underlineText
    });
  }

  render() {
    return SimpleDropDownTemplate.apply(this);
  }
}

SimpleDropDown.propTypes = {
  onChange: PropTypes.func.isRequired,
  isOpened: PropTypes.bool,
  activeValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  values: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  underlineText: PropTypes.string,
  label: PropTypes.string
}

export default injectIntl(SimpleDropDown);
